// extracted by mini-css-extract-plugin
module.exports = {"btn":"f_p"};